import { renderTitle, useBreadcrumbs } from '@/_shared/hooks/useBreadcrumbs';
// import envConfig from '@/_shared/models/enviroment.model';
import { useWindowSize } from '@uidotdev/usehooks';
import { useSession } from 'next-auth/react';
import Head from 'next/head';
import { useRouter } from 'next/router';
import { ReactNode, useEffect, useRef } from 'react';
import {
  getSafeAuthRedirectUrl,
  syncSafeAuthCallbackUrlCookie,
} from '@/_shared/utils/auth-redirect.utils';

interface AuthPagesScaffoldProps {
  children: ReactNode;
}

const AuthPagesScaffold = ({ children }: AuthPagesScaffoldProps) => {
  const breadcrumbs = useBreadcrumbs();
  const router = useRouter();
  const hasRedirected = useRef(false);
  const { data: session, status } = useSession();

  const isMaintenancePage = router.pathname === '/maintenance';

  useEffect(() => {
    if (!router.isReady) return;
    if (isMaintenancePage) return;

    syncSafeAuthCallbackUrlCookie(router.query.callbackUrl);

    if (status === 'authenticated' && session?.user) {
      // Only redirect if user has complete authentication status
      if (session.user.status === 'complete' && !hasRedirected.current) {
        hasRedirected.current = true;
        if (session.user.consent === 'false') {
          router.push(`/accept-terms-of-use?user=${session.user.id}`);
        } else {
          router.push(getSafeAuthRedirectUrl(router.query.callbackUrl));
        }
      }
    }
  }, [
    session,
    status,
    router,
    isMaintenancePage,
    router.isReady,
    router.query.callbackUrl,
  ]);

  const { height } = useWindowSize();
  const isRegisterPage = router.pathname === '/register';

  return (
    <main>
      <Head>
        <title>{`MeterCube${renderTitle(breadcrumbs)}`}</title>
      </Head>
      <main
        className={`flex ${
          isRegisterPage ? 'min-h-screen' : 'h-screen'
        } justify-center items-center sm:px-3 max-sm:items-end bg-global-secondary ${
          height && height < 560
            ? 'max-sm:pt-[calc(100vh-420px)]'
            : 'max-sm:pt-[140px]'
        } max-sm:overflow-y-auto max-sm:max-h-full max-sm:h-full`}
      >
        <div className="w-full sm:w-fit lg:w-[1240px] sm:rounded-3xl rounded-t-3xl bg-white shadow-lg">
          {children}
        </div>
      </main>
    </main>
  );
};

export default AuthPagesScaffold;
